import { useConvexAction } from '@convex-dev/react-query'
import { api } from '@cvx/_generated/api'
import { useMutation } from '@tanstack/react-query'

interface CheckoutArgs {
  readonly productIds: string[]
  readonly origin: string
  readonly successUrl: string
}

/**
 * Provides role-gated actions for redirecting to Polar checkout and the customer portal.
 * Checkout requires admin or owner role. Customer portal requires owner role.
 */
export function useBillingActions() {
  const { mutateAsync: generateCheckoutLink } = useMutation({
    mutationFn: useConvexAction(
      api.features.billing.billing_settings.generateMyCheckoutLink,
    ),
  })

  const { mutateAsync: generateCustomerPortalUrl } = useMutation({
    mutationFn: useConvexAction(
      api.features.billing.billing_settings.generateMyCustomerPortalUrl,
    ),
  })

  const redirectToCheckout = async (args: CheckoutArgs): Promise<void> => {
    const { url } = await generateCheckoutLink(args)
    window.location.href = url
  }

  const redirectToCustomerPortal = async (): Promise<void> => {
    const { url } = await generateCustomerPortalUrl({})
    window.location.href = url
  }

  return { redirectToCheckout, redirectToCustomerPortal }
}
